import { quickEntries } from "@/mocks/home";

export default function QuickNav() {
  return (
    <section className="pb-14 md:pb-20 bg-background-50">
      <div className="mx-auto max-w-content px-4 md:px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {quickEntries.map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              className="group flex flex-col gap-3 p-5 rounded-lg bg-background-100 border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
            >
              <span className="w-11 h-11 flex items-center justify-center rounded-md bg-primary-100 text-primary-700">
                <i className={`${item.icon} text-xl`} />
              </span>
              <h3 className="font-heading text-base font-semibold text-foreground-950">
                {item.title}
              </h3>
              <p className="text-sm leading-relaxed text-foreground-600">{item.desc}</p>
              <span className="mt-auto inline-flex items-center gap-1 text-xs font-label text-primary-700">
                前往查看
                <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" />
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}